import React from 'react';
import PropTypes from 'prop-types';
import parseMarkdownTable from '../../helpers/parseMarkdownTable';

function MarkdownTableRenderer({ className='', markdown }) {
  
    const { headers, rows } = parseMarkdownTable(markdown);
  
    const tableContainerClassName = `custom-markdown-table-container ${className}-table-container`;
    const tableClassName = `custom-markdown-table ${className}-table`;
    const trClassName = `custom-markdown-tr ${className}-tr`;
    const thClassName = `custom-markdown-th ${className}-th`;
    const tdClassName = `custom-markdown-td ${className}-td`;

    return (
        <div className={tableContainerClassName}>
        <table className={tableClassName}>
            {headers && headers.length > 0 && (
                <thead>
                     <tr className={trClassName}>
                        {headers.map((header, index) => (
                            <th key={index} className={thClassName}>{header}</th>
                          ))}
                    </tr>
                </thead>
            )}
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className={trClassName}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={tdClassName}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
}

MarkdownTableRenderer.propTypes = {
  markdown: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MarkdownTableRenderer;
